const dateFormat = {
  mmddyy: timestamp => new Date(timestamp).toLocaleDateString('en-US'),
  mmddyyyy: timestamp => new Date(timestamp).toLocaleDateString('en-US')
};

export default dateFormat;
